import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { Snapshot, CreateSnapshotDto } from 'types';
import { convertSnapshot } from 'api/dtoConverters';

export const createSnapshot = async ({
  data,
}: {
  data: CreateSnapshotDto;
}): Promise<Snapshot> => {
  const response = await axios.post('/api/snapshots', convertSnapshot(data));
  return response.data as Snapshot;
};

type UseCreateSnapshotOptions = {
  analyzerId: number;
  config?: MutationConfig<typeof createSnapshot>;
};

export const useCreateSnapshot = ({
  config,
  analyzerId,
}: UseCreateSnapshotOptions) => {
  return useMutation({
    onMutate: async (newSnapshot) => {
      await queryClient.cancelQueries(['snapshots', analyzerId]);

      const previousSnapshots = queryClient.getQueryData<Snapshot[]>([
        'snapshots',
        analyzerId,
      ]);

      queryClient.setQueryData(
        ['snapshots', analyzerId],
        [...(previousSnapshots || []), newSnapshot.data]
      );

      return previousSnapshots;
    },
    onError: (_, __, context: any) => {
      if (context?.previousSnapshots) {
        queryClient.setQueryData(
          ['snapshots', analyzerId],
          context.previousSnapshots
        );
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['snapshots', analyzerId]);
      queryClient.invalidateQueries(['snapshots', 'list']);
    },
    ...config,
    mutationFn: createSnapshot,
  });
};
